module.exports = __webpack_public_path__ + "static/media/workbg-camping.8ba298e7.jpg";